<script>
  import Button from "lib/components/Button.svelte";

  const PrivacyPolicyLink = "https://paxray.com/privacypolicy/";
  const ImprintLink = "https://paxray.com/imprint/";
  const ContactEmail = "info@paxray.com";

  /** @param {string} url */
  function openExternal(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }
</script>

<div class="footer-links">
  <Button
    variant="paxAI"
    size="sm"
    text="Contact"
    on:click={() => (window.location.href = `mailto:${ContactEmail}`)}
  />
  <Button
    variant="paxAI"
    size="sm"
    text="Privacy Policy"
    on:click={() => openExternal(PrivacyPolicyLink)}
  />
  <Button
    variant="paxAI"
    size="sm"
    text="Imprint"
    on:click={() => openExternal(ImprintLink)}
  />
</div>

<style>
  .footer-links {
    position: absolute;
    bottom: 1.5rem;
    right: 1.5rem;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
</style>
